
import { Component, Vue } from 'vue-property-decorator'
import Header from '@/components/componentWap/Header.vue'
import { baseSearch } from '@/api'
import { brightenKeyWord } from '@/utils/brightenKeyWord'
@Component({
    name: 'Search',
    components: {
        Header
    }
})
export default class extends Vue {
    private keyWord: string = ''
    private editData = {}
    private timeout: any = 0
    private BrightenKeyWord = brightenKeyWord
    private goBack() {
        this.$router.back()
    }
    // 远程搜索
    private async querySearch(queryString: String) {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(async () => {
            if (!queryString) {
                this.editData = {}
                return
            }
            this.getBaseSearch()
        }, 200)
    }
    private async getBaseSearch() {
        let res = await baseSearch(this.keyWord)
        this.editData = res.data
    }
    // 文章详情
    private docClick(id: string) {
        location.href = `/helpCenter/${this.$route.params.ntwId}/Question/QuestionDetail?questionId=${id}&keyWord=${this.keyWord}`
    }
    // 视频详情
    private videoClick(id: string) {
        location.href = `/helpCenter/${this.$route.params.ntwId}/Video/VideoDetail?videoId=${id}&keyWord=${this.keyWord}`
    }
    // 搜索结果
    private onSubmit() {
        location.href = `/helpCenter/${this.$route.params.ntwId}/SearchResult?keyWord=${this.keyWord}`
    }
}
